import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const positionFallback = 'top';

const Tooltip = ({
  children,
  title,
  html,
  position = positionFallback,
  trigger = 'mouseenter focus',
  interactive = false,
  arrow = false,
  distance = 10,
  theme,
  size,
  disabled,
  delay,
  hideDelay,
  duration,
  hideDuration,
  hideOnClick,
  className,
  style,
  ...rest
}) => {
  const content = html ?? title;
  const isDisabled = disabled || content == null || content === '';
  const contentAllowsHtml = typeof content === 'string' && (
    html != null || content.includes('<')
  );
  const normalizedTrigger = trigger === 'manual' ? undefined : trigger;

  return (
    <Tippy
      content={content}
      allowHTML={contentAllowsHtml}
      placement={position}
      trigger={normalizedTrigger}
      interactive={interactive}
      arrow={arrow}
      offset={[0, distance]}
      disabled={isDisabled}
      delay={delay}
      duration={duration}
      hideOnClick={hideOnClick}
      className={className}
      theme={theme}
      {...rest}
    >
      {children}
    </Tippy>
  );
};

export default Tooltip;
